import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  PÉLDÁNYOK és ÁTADÁS-ÁTVÉTEL.
 *
 *  Az irat a tartalom, a példány a megjelenése: eredeti, másolat vagy hiteles másolat,
 *  fizikai hellyel és őrzővel. Ha nem tartjuk nyilván, kiderül ugyan az iktatókönyvből,
 *  hogy létezik egy irat, de nem az, hogy melyik fiókban van.
 *
 *  Átadásnál a felelősség CSAK az átvétel visszaigazolásakor száll át – nincs olyan
 *  állapot, hogy az irat „úton van", és közben senki nem felel érte.
 */
@Component({
  selector: 'app-ikt-peldanyok',
  templateUrl: './peldanyok.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktPeldanyokComponent implements OnInit {
  nezet: 'peldanyok' | 'atadas' = 'peldanyok';
  szoveg = '';
  csakSajat = false;

  peldanyok: any[] = [];
  atadasok: any[] = [];
  ugyintezok: any[] = [];
  en = '';
  betoltes = false;

  constructor(private ikt: IktatgatoService, private data: DataService, private router: Router) {}

  async ngOnInit() {
    this.en = await this.ikt.ki();
    try { this.ugyintezok = await this.ikt.ugyintezok(); } catch { this.ugyintezok = []; }
    await this.betolt();
  }

  async betolt() {
    this.betoltes = true;
    try {
      const szuro: any = { kereses: this.szoveg.trim() };
      if (this.csakSajat) szuro.orzo = this.en;
      this.peldanyok = await this.ikt.peldanyok(szuro);
      this.atadasok = await this.ikt.atadasok(this.csakSajat ? { sajat: 1 } : {});
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A példányok nem tölthetők be.', 'error');
    } finally { this.betoltes = false; }
  }

  allapotSzin(p: any) {
    if (p.allapot === 'atadas_alatt') return 'warning';
    if (p.allapot === 'irattarban') return 'medium';
    if (p.allapot === 'megsemmisitve') return 'danger';
    return 'success';
  }

  async atad(p: any) {
    const kinek = window.prompt(
      `Kinek adod át a(z) ${p.iktatoszam} ${p.sorszam}. példányát?\n`
      + 'Írd be a felhasználónevét (az átvevőnek vissza kell igazolnia).') || '';
    if (!kinek.trim()) return;
    try {
      await this.ikt.atad({ targy_tipus: 'peldany', targy_id: p.id, atvevo: kinek.trim() });
      this.data.sendToast('Átadás elindítva – az átvevő visszaigazolására vár.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átadás nem sikerült.', 'error');
    }
  }

  async atvesz(a: any) {
    try {
      await this.ikt.atvetel(a.id, {});
      this.data.sendToast('Átvéve – innentől nálad van nyilvántartva.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átvétel nem sikerült.', 'error');
    }
  }

  async visszautasit(a: any) {
    const indok = window.prompt('A visszautasítás indoka (kötelező):') || '';
    if (!indok.trim()) return;
    try {
      await this.ikt.atvetel(a.id, { visszautasit: true, indok: indok.trim() });
      this.data.sendToast('Visszautasítva – a példány az átadónál marad.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A művelet nem sikerült.', 'error');
    }
  }

  iratra(p: any) { this.router.navigateByUrl('/iktatgato/irat/' + p.irat); }
}
